module.exports = __webpack_public_path__ + "assets/img/3_1393_big.51a81450.jpg";